module.exports = __webpack_public_path__ + "assets/img/jianjiang01.4b6d3ee5.png";